<template>
    <v-container fluid>
        <div class="modal-padding">
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="center-name">
                        Are you sure you want to delete?
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="right-align yes-no-block">
                        <v-btn
                            @click="
                                onClose({
                                    status: false,
                                    action: 'yes',
                                    is_delete: true,
                                    isTeacher,
                                    ...data,
                                })
                            "
                            class="right-btn cust-btn"
                            color="primary"
                            >Yes</v-btn
                        >
                        <v-btn
                            @click="
                                onClose({
                                    status: false,
                                    action: 'no',
                                    is_delete: false,
                                    isTeacher,
                                    ...data,
                                })
                            "
                            class="right-btn cust-btn no-btn"
                            color="primary"
                            >No</v-btn
                        >
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "DeleteUser",
    props: ["onClose", "data"],
    data() {
        return {
            isTeacher: false,
        };
    },
    methods: {
        ...mapActions({
            getTeacherDetails: "userStore/getTeacherDetails",
        }),
        getAlreadySelectedBatches() {
            const reqData = {
                teacher_id: this.data.id,
            };
            let tempcenter = [];
            let tempBatches = [];
            this.getTeacherDetails(reqData)
                .then((response) => {
                    let selectedCenter = [];
                    if (
                        response.batches.length > 0 &&
                        response.centerBatches.length > 0
                    ) {
                        this.data.toBeDelete = true;
                    } else {
                        this.data.toBeDelete = false;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            return tempcenter;
        },
    },
    mounted() {
        if (this.data && this.data.isTeacher) {
            this.getAlreadySelectedBatches();
        }
    },
    watch: {
        data() {
            if (this.data && this.data.isTeacher) {
                this.getAlreadySelectedBatches();
            }
        },
    },
};
</script>
